/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EvmNft,
    EvmNftFromJSON,
    EvmNftFromJSONTyped,
    EvmNftToJSON,
} from './';

/**
 * A list of NFT instances.
 * @export
 * @interface EvmNftListAllOf
 */
export interface EvmNftListAllOf {
    /**
     * A list of L2 EVM NFT (ERC-721, ...) instances.
     * @type {Array<EvmNft>}
     * @memberof EvmNftListAllOf
     */
    evm_nfts: Array<EvmNft>;
}

export function EvmNftListAllOfFromJSON(json: any): EvmNftListAllOf {
    return EvmNftListAllOfFromJSONTyped(json, false);
}

export function EvmNftListAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvmNftListAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'evm_nfts': ((json['evm_nfts'] as Array<any>).map(EvmNftFromJSON)),
    };
}

export function EvmNftListAllOfToJSON(value?: EvmNftListAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'evm_nfts': ((value.evm_nfts as Array<any>).map(EvmNftToJSON)),
    };
}


